import React, { useContext } from 'react';
import { StoreInstance } from '../store';
import { AsyncContent, Expander, JobSearchResults, Spinner } from './sharedComponents';
import componentServices from '../componentServices';
import JobSearchForm from './jobSearchForm';
import router from 'Scripts/router';
import util from 'Scripts/util';
import { ContractPhase, FieldAppContext, IFieldAppQueueItem } from '../contexts/fieldAppProvider';

const SEARCH_KEY = 'inspection-jobs-search';

function TableRow({ jobCostKey, address, installerNames, orderDate, accountingId, isPinned }: 
	IFieldAppQueueItem) {

	const handleClick = (e) => {
		e.preventDefault();
		const { router } = componentServices;

		componentServices.router.pushHistory(router.splicePathSegments(-1, 1, jobCostKey, 'overview'));
	}
	
	return <tr onClick={ handleClick }>
		<td></td>
		<td className='action'><button className={ isPinned? 'icon iconOnly pinned': 'icon iconOnly'}><span></span></button></td>
		<td className='date'><strong>{ orderDate? util.dateHelper.formatDate(orderDate, { format: 'MM/dd/yyyy' }): '-'}</strong></td>
		<td className='relayNumberAccountingId'>{ accountingId }</td>
		<td className='address'>{address}</td>
		<td className='name'>{ installerNames.join(',') }</td>
		<td className='action navigate'></td>
		<td></td>
	</tr>;
}

function Bucket({ title, items, isFetching }: { title: string, items: IFieldAppQueueItem[], isFetching: boolean}) {
	const BucketTable = ({ list }) => {
		const rows = [];
		
		list.forEach(item => rows.push(<TableRow key={item.jobCostKey} { ...item }></TableRow>));

		return (
			<table className="interactive" cellPadding="0" cellSpacing="0">
				<tbody>
					{ rows }
				</tbody>
			</table>
		);
	};

	return <Expander title={title}>
		<AsyncContent hasData={ !!items.length } emptyContent={ !items.length && isFetching? <Spinner classNames={["dark"]} />: 'No Data'}>
			<div className="inner">
				<BucketTable list={ items } />
			</div>
		</AsyncContent>
	</Expander>
}

export default function InspectionQueue({ store }: { store: StoreInstance }) {
	const { fieldState } = useContext(FieldAppContext);
	const searchResults = store.getIn(['viewState', 'searchResults', SEARCH_KEY]);
	const dashboardClasses = ['dashboard inspection'];

	let jobContent: React.ReactElement;

	if(searchResults) {
		dashboardClasses.push('searchResults');

		jobContent = <JobSearchResults
			list={ searchResults.list }
			parameterName={ searchResults.searchParameter.name }
			searchText= { searchResults.searchText }
			onJobClick= { (j) => router.pushHistory(router.pushPathSegments(j.key)) } />;
	}
	else {
		// TODO: create buckets for each phase, pinned, 10% (and unknown?)
		jobContent = <React.Fragment>
			<Bucket title={ContractPhase.inspect} items={fieldState.queueItems.filter(i => i.phase === ContractPhase.inspect)} isFetching={fieldState.isFetchingJobs}/>
		</React.Fragment>
	}

	return <div className={ dashboardClasses.join(' ') }>
		<JobSearchForm searchKey={ SEARCH_KEY } />
		{ jobContent }
	</div>;
}
